import { collection, addDoc, query, where, getDocs, getDoc, updateDoc, doc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { updateNotificationsAggregationOnCreate } from './notificationsAggregations';
import { updatePetsAggregationOnUpdate } from './petsAggregations';

// Variável para controlar execução simultânea
let isChecking = false;

// Verificar planos que encerraram e gerar notificações
export const checkMonthlyPlanEnding = async () => {
  // Prevenir execuções simultâneas
  if (isChecking) {
    return;
  }
  
  isChecking = true;
  try {
    const now = new Date();
    
    // Buscar pets do agregado (reduz leituras do Firestore)
    const petsAggregateRef = doc(db, 'agregadoPets', 'all');
    const petsAggregateDoc = await getDoc(petsAggregateRef);
    
    if (!petsAggregateDoc.exists()) {
      // Agregado não existe, não fazer nada
      isChecking = false;
      return;
    }
    
    const aggregateData = petsAggregateDoc.data();
    const allPets = aggregateData.pets || [];
    
    // Filtrar apenas pets com plano mensal ativo
    const petsWithActivePlan = allPets.filter(pet => {
      const hasPlan = pet.planoMensal === true;
      return hasPlan;
    });
    
    for (const pet of petsWithActivePlan) {
      
      // Buscar todos os agendamentos recorrentes do plano
      const appointmentsQuery = query(
        collection(db, 'agendamentos'),
        where('idPet', '==', pet.id),
        where('eRecorrente', '==', true),
        where('origemRecorrente', '==', 'monthly_plan')
      );
      
      const appointmentsSnapshot = await getDocs(appointmentsQuery);
      
      // Verificar se há agendamentos futuros
      let hasFutureAppointments = false;
      
      appointmentsSnapshot.docs.forEach(doc => {
        const appointment = doc.data();
        if (appointment.dataAgendamento) {
          let appointmentDate;
          if (appointment.dataAgendamento.toDate) {
            appointmentDate = appointment.dataAgendamento.toDate();
          } else if (appointment.dataAgendamento instanceof Date) {
            appointmentDate = appointment.dataAgendamento;
          } else {
            appointmentDate = new Date(appointment.dataAgendamento);
          }
          
          const isFuture = appointmentDate.getTime() > now.getTime();
          
          // Verificar se o agendamento é futuro (maior que agora)
          if (isFuture) {
            hasFutureAppointments = true;
          }
        }
      });
      
      // Se não há agendamentos futuros, encerrar o plano imediatamente
      // Isso inclui casos onde não há agendamentos nenhum ou todos já passaram
      if (!hasFutureAppointments) {
        try {
          // Verificar novamente se o plano ainda está ativo antes de criar notificação
          const petRef = doc(db, 'pets', pet.id);
          const petSnap = await getDoc(petRef);
          
          if (petSnap.exists()) {
            const currentPetData = petSnap.data();
            
            // Se o plano já foi desativado, não criar notificação
            if (!currentPetData.planoMensal) {
              // Plano já desativado, não fazer nada
            } else {
              // Criar notificação e desativar o plano
              const notificationData = {
                tipo: 'plan_expired',
                titulo: `Plano de ${pet.nome} encerrou`,
                mensagem: `O plano mensal de ${pet.nome} encerrou. Não há mais agendamentos futuros. Considere renovar o plano.`,
                idPet: pet.id,
                nomePet: pet.nome,
                lida: false,
                criadoEm: Timestamp.now()
              };
              
              const notificationRef = await addDoc(collection(db, 'notificacoes'), notificationData);
              
              // Atualizar agregado de notificações
              try {
                await updateNotificationsAggregationOnCreate({
                  id: notificationRef.id,
                  ...notificationData
                });
              } catch (err) {
                // Erro ao atualizar agregado de notificações
              }
              
              // Desativar plano
              await updateDoc(petRef, {
                planoMensal: false,
                atualizadoEm: Timestamp.now()
              });
              
              // Atualizar agregado de pets
              try {
                await updatePetsAggregationOnUpdate({
                  ...currentPetData,
                  id: pet.id,
                  planoMensal: false,
                  atualizadoEm: Timestamp.now()
                });
              } catch (err) {
                // Erro ao atualizar agregado de pets
              }
            }
          }
        } catch (queryError) {
          // Erro ao criar notificação
        }
      }
    }
  } catch (error) {
    // Erro ao verificar planos encerrados
  } finally {
    isChecking = false;
  }
};










